import { Application } from "@verity/proctoring-option/types";
import { useState } from "react";
import { useMobileLayout } from "../../../hooks";
import i18nPackage from "../../../i18n/i18n";
import { CoreModal, CoreModalDescription, CoreTextField } from "../../../core";
import { Trans } from "react-i18next";
import { FormControlLabel, Link, Typography } from "@mui/material";
import styles from "./AddApplication.module.css";
import { BlockApplicationListMode } from "../option-lists/BlockApplicationList";

export default function AddProcessNameModal({
	action,
	setShowAddModal,
	onAddExtension,
}: {
	action: BlockApplicationListMode;
	setShowAddModal: React.Dispatch<React.SetStateAction<boolean>>;
	onAddExtension: (extension: Application) => void;
}) {
	const [processName, setProcessName] = useState<string>("");
	const isMobileLayout = useMobileLayout();
	const windowAriaLabel = i18nPackage.t("editQuizPage.configurationStep.addApplicationModal.osLinkAria", {
		os: "Windows",
	});
	const macAriaLabel = i18nPackage.t("editQuizPage.configurationStep.addApplicationModal.osLinkAria", {
		os: "Mac",
	});

	return (
		<CoreModal
			open
			onClose={() => setShowAddModal(false)}
			title={i18nPackage.t("editQuizPage.configurationStep.addApplicationModal.title")}
			minWidth={isMobileLayout ? "100%" : "min(60%, 600px)"}
			widthFixed
			contentMatchModalHeight
			padding={isMobileLayout ? "10px 24px" : undefined}
			buttons={[
				{
					text: i18nPackage.t("editQuizPage.configurationStep.addApplicationModal.cancel"),
					color: "secondary",
					onClick: () => setShowAddModal(false),
				},
				{
					text: i18nPackage.t("editQuizPage.configurationStep.addApplicationModal.add"),
					color: "primary",
					onClick: () => {
						const processNames = [processName];
						if (processName.includes(".")) {
							processNames.push(processName.split(".")[0]);
						}
						onAddExtension({ processName: processNames, name: processName, type: "Other" });
						setShowAddModal(false);
					},
					disabled: processName === "",
				},
			]}
		>
			<CoreModalDescription>
				{i18nPackage.t(`editQuizPage.configurationStep.addApplicationModal.firstParagraph.${action}`)}
			</CoreModalDescription>

			<CoreModalDescription>
				<Trans
					i18n={i18nPackage}
					i18nKey="editQuizPage.configurationStep.addApplicationModal.secondParagraph"
					components={{
						bold: <strong />,
						windowsLink: (
							<Link
								href="https://support.yuja.com/hc/en-us/articles/19811973185943-Creating-a-Blocked-Application-List-for-the-Proctored-Assessment#h_01HPSEPZK158TSA1P74ZBMHYWC"
								target="_blank"
								rel="noopener noreferrer"
								className={styles.applicationLink}
								aria-label={windowAriaLabel}
							/>
						),
						macLink: (
							<Link
								href="https://support.yuja.com/hc/en-us/articles/19811973185943-Creating-a-Blocked-Application-List-for-the-Proctored-Assessment#01JWGV5CPBYPDYA6XAMK8MQT2N"
								target="_blank"
								rel="noopener noreferrer"
								className={styles.applicationLink}
								aria-label={macAriaLabel}
							/>
						),
					}}
				/>
			</CoreModalDescription>

			<FormControlLabel
				control={
					<CoreTextField value={processName} onChange={(e) => setProcessName(e.target.value)} sx={{ width: "100%" }} />
				}
				label={
					<Typography className={styles.addApplicationLabel}>
						{i18nPackage.t("editQuizPage.configurationStep.addApplicationModal.applicationNameLabel")}
					</Typography>
				}
				className={styles.addApplicationFormControl}
				labelPlacement="top"
			/>
		</CoreModal>
	);
}
